export const STATUS_COLORS: Record<string, string> = {
  new: "bg-blue-500/10 text-blue-600 border-blue-200",
  initiated: "bg-primary/10 text-primary border-primary/20",
  converted: "bg-success/10 text-success border-success/20",
  temporary: "bg-accent/10 text-accent border-accent/20",
  invalid: "bg-destructive/10 text-destructive border-destructive/20",
};
